<sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
  <sc-title>{{'details station set' | translate: ['tmc.admin.yard-structure.stationset-details.title',
    translationService.language]}}</sc-title>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <div>
    <div class="stationset-station">
      <div class="stationset-header">
        <div class="header-fields-container">
          <mat-form-field style="grid-column: 1 / span 1; grid-row: 1 / span 1;" appearance="fill">
            <mat-label>{{'externalKey' | translate: ['tmc.stationgroup.stationset.externalKey.label',
              translationService.language]}}</mat-label>
            <input [(ngModel)]="stationSet.externalKey" #ctrlExternalKey="ngModel" name="{{'stationSetExternalKey'}}"
              matInput [required]="true" [maxlength]="50" [minlength]="1" />
          </mat-form-field>
          <mat-form-field style="grid-column: 2 / span 2; grid-row:  1 / span 1;" appearance="fill">
            <mat-label>{{'name' | translate: ['tmc.stationgroup.stationset.name', translationService.language]}}
            </mat-label>
            <input [(ngModel)]="stationSet.name" #ctrlName="ngModel" name="{{'stationSetName'}}" matInput
              [required]="true" [maxlength]="255" />
          </mat-form-field>
          <mat-form-field style="grid-column: 4 / span 1; grid-row: 1 / span 1;" appearance="fill">
            <mat-label>{{'internal' | translate: ['tmc.stationgroup.stationset.internal', translationService.language]}}
            </mat-label>
            <input [(ngModel)]="stationSet.internal" #ctrlName="ngModel" name="{{'stationSetInternal'}}" matInput
              [required]="false" [maxlength]="255" />
          </mat-form-field>
          <mat-form-field style="grid-column: 5 / span 1; grid-row: 1 / span 1;" appearance="fill">
            <mat-label>{{'referenceDuration' | translate: ['tmc.stationgroup.stationset.referenceDuration.label',
              translationService.language]}}</mat-label>
            <input [(ngModel)]="stationSet.referenceDuration" #ctrlReferenceDurationKey="ngModel"
              name="{{'referenceDuration'}}" matInput appPositiveInteger type="number" min="0" />
          </mat-form-field>
          <mat-form-field style="grid-column: 1; grid-row: 2 / span 1;" appearance="fill">
            <mat-label>
              {{'Type' | translate: ['tmc-yard.entity.station-set.station-set-type', translationService.language]}}
            </mat-label>
            <mat-select [(ngModel)]="stationSet.stationSetType" name="stationSetType">
              <mat-option *ngFor="let o of stationSetTypes" value="{{o}}">
                {{o | translate: ['tmc-yard.entity.station-set.station-set-type.' + o,
                translationService.language]}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="grid-column: 2 / span 4; grid-row: 2 / span 1;" appearance="fill">
            <mat-label>{{'description' | translate: ['tmc.stationgroup.stationset.description',
              translationService.language]}}</mat-label>
            <textarea cdkTextareaAutosize [(ngModel)]="stationSet.description" name="{{'stationSetDescription'}}"
              matInput [required]="false" [maxlength]="255">
        </textarea>
          </mat-form-field>
        </div>
        <!-- Show error messages -->
        <div class="table-row">
          <app-service-response [responseMessages]="responseMessages"></app-service-response>
        </div>
      </div>

      <sc-content-spacer [vertical]="true"></sc-content-spacer>
    </div>
  </div>
  <sc-flex-fitting-content [vertical]="true">

    <mat-tab-group>
      <mat-tab
        label="{{'stations' | translate: ['tmc.stationgroup.stationset.tab.stations', translationService.language]}}">

        <sc-scroll-pane>
          <div class="station-list" cdkDropList (cdkDropListDropped)="dropStation($event)">

            <div class="draggable-form-box station" cdkDrag *ngFor="let station of stationSet.stations">

              <mat-form-field class="station-name ">
                <input matInput [(ngModel)]="station.name" [ngModelOptions]="{standalone: true}"
                  placeholder="{{'name' | translate: ['tmc.stationgroup.stationset.stations.table.column.name', translationService.language]}}"
                  [readonly]="true">
              </mat-form-field>

              <mat-form-field class="station-description ">
                <input matInput [(ngModel)]="station.description" [ngModelOptions]="{standalone: true}"
                  placeholder="{{'description' | translate: ['tmc.stationgroup.stationset.stations.table.column.description', translationService.language]}}"
                  [readonly]="true">
              </mat-form-field>

              <div class="delete-button-wrapper">
                <sc-icon iconClass="fa-trash" (click)="removeStationFromStationSet(station)"></sc-icon>
              </div>
            </div>
            <div class="button-wrapper">
              <button class="add-button" mat-flat-button type="button" (click)="addStationToStationSet()">
                <sc-icon iconClass="fa-plus fa-2x"></sc-icon>
              </button>
            </div>
          </div>
        </sc-scroll-pane>

      </mat-tab>
      <mat-tab label="{{'backup structures' | translate: ['tmc.stationgroup.stationset.tab.backup-structures',
      translationService.language]}}">

        <sc-padding>

          <app-backup-reference [reference]="backupStationSet" *ngFor="let backupStationSet of stationSet.backupStationSets" (onDelete)="removeBackupStationSet($event)"></app-backup-reference>

          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <sc-flex [centered]="true">
            <button class="add-button" mat-flat-button type="button" (click)="addBackupStationSet()">
              <sc-icon iconClass="fa-plus fa-2x"></sc-icon>
            </button>
          </sc-flex>

        </sc-padding>

      </mat-tab>
    </mat-tab-group>

  </sc-flex-fitting-content>
</sc-flex>
<!-- Loading spinner to prevent user from doing anything during validation. -->
<div class="loading-spinner" *ngIf="requestRunning">
  <i class="spinner fa-light fa-spinner fa-spin"></i>
</div>
